import SmoothScroll from 'smooth-scroll';

export default function scrollAnchor(element) {
  const navHeader = element;
  const hashAnchor = window.location.hash;
  if (hashAnchor) {
    const scrollhash = new SmoothScroll();
    const anchor = document?.querySelector(hashAnchor);
    const toggle = document?.querySelector(`a[href*="${window.location.hash}"]`);
    const options = {
      header: navHeader,
      offset: -24,
    };
    if (anchor) {
      scrollhash.animateScroll(anchor, toggle, options);
    }
  }
}

export function scrollAnchorWithoutMenu() {
  const hashAnchor = window.location.hash;
  if (hashAnchor) {
    const anchor = document.querySelector(hashAnchor);
    if (anchor) {
      anchor.scrollIntoView(
        {
          behavior: 'smooth',
          block: 'start',
        },
      );
    }
  }
}
